import React, { useState } from 'react';

const SearchFilter = ({ onSearch, onReset }) => {
    const [filterData, setFilterData] = useState({
        keyword: { name: 'keyword', value: '' },
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterData((prev) => ({
            ...prev,
            [name]: { ...prev[name], value }
        }));
    };
    const handleSearch = () => {
        const modelPayload = {
            keyword: filterData.keyword.value?.trim() || ''
        };
        const encodedPayload = btoa(JSON.stringify(modelPayload));

        if (onSearch) {
            onSearch(encodedPayload); // Send base64 string to parent
        }
    };


    const handleReset = () => {
        const resetData = {
            keyword: { name: 'keyword', value: '' },
        };
        setFilterData(resetData);
        if (onReset) {
            onReset(resetData);
        }
    };

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="row gy-12 gx-12 align-items-center">
                            <div className="col-sm-2">
                                <label htmlFor="searchKeyword">
                                    Search Yard
                                </label>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-group">
                                    <input
                                        type="text"
                                        name="keyword"
                                        id="searchKeyword"
                                        className="form-control"
                                        value={filterData.keyword.value}
                                        onChange={handleChange}
                                        placeholder="Enter Yard ID, Yard Name, Yard Code etc"
                                    />
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <button
                                    type="button"
                                    onClick={handleSearch}
                                    className="btn btn-success waves-effect btn-label waves-light"
                                    style={{
                                        backgroundImage: "linear-gradient(90deg, #0ddcef, #319bfc)"
                                    }}
                                >
                                    <i className="bx bx-check-double label-icon" /> Search
                                </button>
                                &nbsp;
                                <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    onClick={handleReset}
                                >
                                    Reset
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchFilter;
